import * as types from './companyInsights.types';

const initialState = {
  data: null,
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_INSIGHTS_START:
      return {
        ...state,
        data: null,
        isLoading: true,
      };

    case types.GET_COMPANY_INSIGHTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case types.GET_COMPANY_INSIGHTS_FAILS:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return { ...state };
  }
};
